import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PageAuthorize from '../../../../security/PageAuthorize';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import ReactTooltip from 'react-tooltip';
import Overlay from '../../../../presentation/Overlay';
import DeleteDialog from './DeleteDialog';

import * as wj from 'wijmo/wijmo.react.grid';
import * as wijmo from 'wijmo/wijmo';
import * as wjcGrid from 'wijmo/wijmo.grid';

// Wijmo Key
wijmo.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

class FileDetailsDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      show: props.show === undefined ? false : props.show,
      loading: true,
      fileContents: [{ NUMBER: 'Loading' }],
      fileUses: [{ PROCESSED_ON: 'Loading' }],
      programs: [],
      errors: [],
      programTypes: [],
      defaultPrograms: [],
      destination: '0',
      type: '',
      DEST_ID: '',
      description: '',
      programType: '',
      DEFDNIS: '',
      progress: '',
      deleteBody: '',
      selectedItem: {},
      showDeleteFromDNIS: false
    };

    // Bindable events
    this.onClose = this.onClose.bind( this );
    this.onHandleChange = this.onHandleChange.bind( this );
    this.formatCell = this.formatCell.bind( this );
    this.onClickDeleteFromDNIS = this.onClickDeleteFromDNIS.bind( this );
    this.onCloseDeleteFromDNISDialog = this.onCloseDeleteFromDNISDialog.bind( this );
    this.onOpenDeleteFromDNISDialog = this.onOpenDeleteFromDNISDialog.bind( this );
    this.onClickApplyToDNIS = this.onClickApplyToDNIS.bind( this );
    this.refreshErrors = this.refreshErrors.bind( this );
    this.refreshUses = this.refreshUses.bind( this );

    // Fields / Properties
    this.wijmoGrid = React.createRef(); // Grid for file uses
    this.wijmoPanel = null;
    this.wijmoGrid2 = React.createRef(); // Grid for file errors
    this.wijmoPanel2 = null;
    this.wijmoGrid3 = React.createRef(); // Grid for file contents
    this.wijmoPanel3 = null;
    this._mounted = false;
    this.buttonEvents = [];
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillReceiveProps( nextProps ) {
    if ( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        show: nextProps.show === undefined ? false : nextProps.show
      }, () => {
        if ( this.state.show && this._mounted ) {
          const fileUploadSearchParams = [
            { FL_FILE_ID: this.props.filedata.FL_FILE_ID }
          ];

          Promise.all( [
            this.getFileContents(),
            this.fileUploadSearch( fileUploadSearchParams ),
            this.getPrograms(),
            this.programListsUtility( [{ COLUMN_NAME: 'ROUTING_TYPE_ID' }] ),
            this.programListsUtility( [{ COLUMN_NAME: 'PDNIS' }] )
          ] )
            .then( ( [fileContents, fileUses, programs, programTypesResults, defaultProgramsResults] ) => {
              this.setState( {
                fileContents: fileContents,
                fileUses: fileUses,
                programs: programs,
                programTypes: programTypesResults,
                defaultPrograms: defaultProgramsResults,
                loading: false
              } );
            } ).catch( ( exception ) => {
              this.onHandleException( exception );
            } );
        }
      } );
    }
  }

  compareProps( props, nextProps ) {
    if ( props.show !== nextProps.show ) {
      return true;
    }

    return false;
  }

  /**
   * Gets the file contents.
   *
   * @returns {Promise} Results of the API call.
   */
  getFileContents() {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/contents' );
      let params = [
        { FL_FILE_ID: this.props.filedata.FL_FILE_ID },
        { START: 1 },
        { END: 1000 }
      ];

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  fileUploadSearch( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/fileuploadsearch' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets all possible programs.
   *
   * @returns {Promise} Results of the API call.
   */
  getPrograms() {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/dnis' );

      if ( api !== undefined ) {
        api.get().then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets the progress for this file when applying to a DNIS.
   */
  getProgress( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/progress' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets the routing types for the dropdowns.
   */
  programListsUtility( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/programlistsutility' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Returns user back to the login page if creds fail.
   */
  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  /**
   * Handles exceptions.
   *
   * @param {Error} e The exception thrown.
   */
  onHandleException( e ) {
    const title = 'File Details Dialog';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( title, e.statusText, 5000 );
      this.doLogOff();
    } else if ( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }

  /**
   * Close event for the dialog.
   *
   * @param {Event} e Closing of the dialog.
   */
  onClose( e ) {
    if ( this.props.onClose !== undefined ) {
      clearInterval( this.progressInterval );

      this.setState( {
        loading: true,
        fileContents: [{ NUMBER: 'Loading' }],
        fileUses: [{ PROCESSED_ON: 'Loading' }],
        programs: [],
        errors: [],
        programTypes: [],
        defaultPrograms: [],
        destination: '0',
        type: '',
        DEST_ID: '',
        description: '',
        programType: '',
        DEFDNIS: '',
        progress: '',
        deleteBody: '',
        selectedItem: {},
        showDeleteFromDNIS: false
      } );

      this.props.onClose( e );
    } else {
      this.setState( {
        show: false
      } );
    }
  }

  /**
   * Closes the dialog.
   *
   * @param {Event} event Closing of the dialog.
   */
  onCloseDeleteFromDNISDialog( event ) {
    let rowSelected = this.wijmoPanel.control.selection.row;

    this.setState( {
      showDeleteFromDNIS: false
    }, () => {
      this.wijmoPanel.control.selection = new wjcGrid.CellRange( rowSelected );
    } );
  }

  /**
   * Opens a dialog to confirm removal of the file from a DNIS.
   *
   * @param {Event} event Clicked to remove the file from the DNIS.
   */
  onOpenDeleteFromDNISDialog( event ) {
    let selectedItem = this.wijmoPanel.control.selectedItems[0];
    let rowSelected = this.wijmoPanel.control.selection.row;

    this.setState( {
      showDeleteFromDNIS: true,
      selectedItem: selectedItem
    }, () => {
      this.wijmoPanel.control.selection = new wjcGrid.CellRange( rowSelected );
    } );
  }

  /**
   * 'Yes' was selected on the confirmation to delete the DNIS that was using
   * this file.
   *
   * @param {Event} event 'Yes' selected to remove file from the DNIS.
   */
  onClickDeleteFromDNIS( event ) {
    const api = new EtelAPI( 'filemanagement/byfilename/deletefromdnis' );
    const selectedItem = this.state.selectedItem;

    this.setState( {
      deleteBody: 'Deleting. Please wait...'
    } );

    api.delete( selectedItem.FILE_UPLOAD_ID ).then( ( result ) => {
      const updatedFileUses = this.state.fileUses.filter( ( fileUse ) => {
        return fileUse.FILE_UPLOAD_ID !== selectedItem.FILE_UPLOAD_ID;
      } );

      this.setState( {
        fileUses: updatedFileUses,
        showDeleteFromDNIS: false,
        deleteBody: '',
        selectedItem: {},
        errors: []
      } );
    } ).catch( ( exception ) => {
      const { dispatch, bugsnag } = this.props;
      const alerts = new Alerts( bugsnag, dispatch );

      if ( [undefined, null, ''].includes( exception.statusText ) ) {
        alerts.CRITICAL( 'Delete File from DNIS', 'Failed to delete file from DNIS.', false );
      } else {
        alerts.CRITICAL( 'Delete File from DNIS', exception.statusText, false );
      }
    } );
  }

  /**
   * Applies the selected file to a selected DNIS.
   *
   * @param {Event} event The click event to apply the file to a DNIS.
   */
  onClickApplyToDNIS( event ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );

    // Check for unfilled values. LEADGEN ON NET is allowed to choose a different DEFDNIS
    if ( this.state.destination === '0' || this.state.type === '' || this.state.DEST_ID === ''
      || ( this.state.destination === '1' && this.state.type === 'ON NET' && this.state.DEFDNIS === '' ) ) {
      alerts.WARNING( 'Apply File to DNIS', 'Please fill out all values.', false );
      return;
    }

    const api = new EtelAPI( 'filemanagement/byfilename/fileuploadinsert' );

    const params = {
      FL_FILE_ID: this.props.filedata.FL_FILE_ID,
      DEFDNIS: this.state.DEFDNIS === '' ? this.state.DEST_ID : this.state.DEFDNIS,
      DEST_ID: this.state.DEST_ID,
      UPLOAD_TYPE: this.state.type === 'TFN' ? 0 : this.state.type === 'OFF NET' ? 1 : 2,
      FILENAME: this.props.filedata.FILENAME,
      DESCRIPTION: this.state.description,
      COUNT_TOTAL: this.props.filedata.COUNT_TOTAL,
      DESTINATION: this.state.destination
    };

    const progressParams = [
      { FL_FILE_ID: params.FL_FILE_ID }
    ];

    api.insert( params ).then( ( result ) => {
      this.setState( {
        fileUses: result.data,
        destination: '0',
        type: '',
        DEST_ID: '',
        description: '',
        programType: '',
        DEFDNIS: '',
      }, () => {
        this.checkProgress( progressParams );

        alerts.SUCCESS( 'Apply File to DNIS', 'Successfully applied file to DNIS.', 2000 );
      } );
    } ).catch( ( exception ) => {
      alerts.CRITICAL( 'Apply File to DNIS', 'Failed to apply file to DNIS.', false );
    } );
  }

  checkProgress( progressParams ) {
    let time = 1;

    this.progressInterval = setInterval( () => {
      this.getProgress( progressParams ).then( ( results ) => {
        let progress = results[0].PROGRESS;

        if ( progress === null || progress === undefined || progress === '' ) {
          this.setState( {
            progress: 'Processing...'
          } );
        } else {
          this.setState( {
            progress: progress
          } );

          if ( progress === 'Complete' ) {
            clearInterval( this.progressInterval );

            // Wait 2 seconds for data to actually be written
            setTimeout( () => {
              this.refreshUses();
            }, 2000 );
          }
        }

        // Failsafe to stop the interval if the progress never reached 'Complete'
        ++time;
        if ( time === 90 ) {
          clearInterval( this.progressInterval );
        }
      } ).catch( ( exception ) => {
        clearInterval( this.progressInterval );
        this.onHandleException( exception );
      } );
    }, 1000 );
  }

  /**
   * Refreshes the errors wijmo grid (if there are any).
   *
   * @param {Event} event
   */
  refreshErrors( event ) {
    const selectedDNIS = this.wijmoPanel.control.selectedItems[0];
    const api = new EtelAPI( 'filemanagement/byfilename/errors' );
    const rowSelected = this.wijmoPanel.control.selection.row;

    if ( selectedDNIS !== null ) {
      api.get( [{ FILE_UPLOAD_ID: selectedDNIS.FILE_UPLOAD_ID }] ).then( ( result ) => {
        this.setState( {
          errors: result
        }, () => {
          this.wijmoPanel.control.selection = new wjcGrid.CellRange( rowSelected );
        } );
      } ).catch( ( exception ) => {
        const { dispatch, bugsnag } = this.props;
        const alerts = new Alerts( bugsnag, dispatch );

        alerts.CRITICAL( 'Retrieve File Use Errors', 'Failed to retrieve any file errors.', false );
      } );
    }
  }

  /**
   * Refreshes the file uses.
   *
   * @param {Event} event
   */
  refreshUses( event ) {
    const fileUploadSearchParams = [
      { FL_FILE_ID: this.props.filedata.FL_FILE_ID }
    ];

    this.fileUploadSearch( fileUploadSearchParams ).then( ( results ) => {
      this.setState( {
        fileUses: results,
        progress: ''
      } );
    } );
  }

  /**
   * Generic event for handling a change event.
   * 
   * @param {Event} event The change event for some type of input. Target must
   * have a name.
   */
  onHandleChange( event ) {
    const name = event.target.name;

    this.setState( {
      [event.target.name]: event.target.value
    }, () => {
      if ( name === 'programType' ) {
        this.programListsUtility( [{ COLUMN_NAME: 'PDNIS' }, { ROUTING_TYPE_ID: this.state.programType }] ).then( ( results ) => {
          this.setState( {
            defaultPrograms: results
          } );
        } ).catch( ( exception ) => {
          this.onHandleException( exception );
        } );
      }

      if ( this.state.type !== 'ON NET' || this.state.destination !== '1' ) {
        this.setState( {
          programType: '',
          DEFDNIS: ''
        } );
      }
    } );
  }

  /**
   * Creates the delete button for each row.
   *
   * @param {*} panel
   * @param {*} r
   * @param {*} c
   * @param {*} cell
   */
  formatCell( panel, r, c, cell ) {
    if ( panel.cellType === 1 ) { // 0 For None, 1 For Cell, 2 for ColumnHeader, 3 for RowHeader
      const col = panel.columns[c];

      // Delete button
      if ( col.binding === '__delete__button' ) {
        const copy_value = panel.getCellData( r, '__delete__button', false );
        if ( copy_value === true ) {
          let id = 'copy_cell_id_' + r.toString() + '_' + c.toString() + '_' + col.index;

          // Altering the cells inner html
          cell.innerHTML = '<div style="display:flex; align-items:center; justify-content: center;width:100%;height:100%;" id="' + id +
            '"><i class="icon-ikons-bin" style="color:#BE000E;font-size:14pt;cursor:pointer;display:flex; align-items:center; justify-content: center;width:100%;height:100%;"/></div>';

          // Create the button press listener
          let buttonCell = document.getElementById( id );
          if ( buttonCell !== undefined ) {

            // Adding the wijmo event to the object, so it can be removed on unmounting
            let copy_listener = new wijmo.Control( buttonCell );
            copy_listener.addEventListener( buttonCell, 'click', this.onOpenDeleteFromDNISDialog );
            this.buttonEvents.push( copy_listener );
          }
        } else {
          cell.innerHTML = '<div></div>';
        }
      }
    }
  }

  /**
   * Renders the dialog header.
   *
   * @returns JSX elements for the dialog's header.
   */
  onRenderHeader() {
    return (
      <DialogHeader caption={`Contents & Uses for ${this.props.filedata.FILENAME}`} closeButton onClose={this.onClose} />
    );
  }

  /**
   * Renders the sidebar containing the file contents.
   *
   * @returns JSX elements for the sidebar file contents.
   */
  onRenderFileContents() {
    return (
      <div className='file-management-file-contents-container'>
        <div
          className='file-management-file-contents-grid-container'
          ref={this.wijmoGrid}
        >
          <div className='file-management-file-contents-header'>Contents</div>
          <wj.FlexGrid
            ref={( panel ) => {
              this.wijmoPanel3 = panel; 
            }}
            itemsSource={this.state.fileContents}
            className='file-management-file-contents-grid'
          >
            <wj.FlexGridColumn width='1.5*' header='NUMBER' binding='NUMBER' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='LENGTH' binding='LENGTH' isContentHtml={true} isReadOnly={true} align='center' />
          </wj.FlexGrid>
        </div>
      </div>
    );
  }

  /**
   * Renders the wijmo grid containing the file uses.
   *
   * @returns JSX elements for the file uses.
   */
  onRenderFileUses() {
    const fileUseRows = ( Object.values( this.state.fileUses ) ).map( ( fileUse ) => {
      return (
        {
          'FL_FILE_ID': fileUse.FL_FILE_ID,
          'FILE_UPLOAD_ID': fileUse.FILE_UPLOAD_ID,
          'DEST_ID': fileUse.DEST_ID,
          'DESTINATION': fileUse.DESTINATION,
          'DEFDNIS': fileUse.DEFDNIS,
          'NAME': fileUse.NAME,
          'PROGRAM_TYPE': fileUse.PROGRAM_TYPE,
          'PDNIS': fileUse.PDNIS,
          'PROGRAM_NAME': fileUse.PROGRAM_NAME,
          'ACTIVE': fileUse.ACTIVE,
          'TYPE': fileUse.TYPE,
          'FILENAME': fileUse.FILENAME,
          'DESCRIPTION': fileUse.DESCRIPTION,
          'USES_COUNT': fileUse.USES_COUNT,
          'ALLOWED_TYPES': fileUse.ALLOWED_TYPES,
          'COUNT_NEW': fileUse.COUNT_NEW,
          'PROCESSED': fileUse.PROCESSED,
          'COUNT_DUPS': fileUse.COUNT_DUPS,
          'COUNT_ERROR': fileUse.COUNT_ERROR,
          'FILECOUNT': fileUse.FILECOUNT,
          'PROCESSED_ON': fileUse.PROCESSED_ON,
          'USER_NAME': fileUse.USER_NAME,
          '__delete__button': true
        }
      );
    } );

    const displayClass = this.state.errors.length === 0
      ? 'file-management-file-uses-container-extended'
      : 'file-management-file-uses-container';

    return (
      <div className={displayClass}>
        <div
          className='file-management-file-uses-grid-container'
          ref={this.wijmoGrid}
          onDoubleClick={this.refreshErrors}
        >
          <div className='file-management-file-uses-header' title='p_api_file_upload_search'>
            <span className='file-management-file-uses-header-item-1'>{this.state.progress ? this.state.progress : `Uses for ${this.props.filedata.FILENAME}`}</span>
            <i className='icon-ikons-repeat file-management-file-uses-header-item-2' data-tip data-for='refresh-uses' onClick={this.refreshUses}></i>
            <ReactTooltip id='refresh-uses'><span>Refresh this grid</span></ReactTooltip>
          </div>
          <wj.FlexGrid
            ref={( panel ) => {
              this.wijmoPanel = panel; 
            }}
            itemsSource={fileUseRows}
            itemFormatter={this.formatCell}
            style={{ height: '100%' }}
            selectionMode='Row'
            className='file-management-file-uses-grid'
          >
            <wj.FlexGridColumn width='*' header='Destination' binding='DESTINATION' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='DNIS' binding='DEFDNIS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Name' binding='NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Program Type' binding='PROGRAM_TYPE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='PDNIS' binding='PDNIS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Program Name' binding='PROGRAM_NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Type' binding='TYPE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Description' binding='DESCRIPTION' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.5*' header='Dups' binding='COUNT_DUPS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.75*' header='Errors' binding='COUNT_ERROR' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Processed' binding='PROCESSED' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Processed On' binding='PROCESSED_ON' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Username' binding='USER_NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.75*' header='Delete' binding='__delete__button' isContentHtml={true} isReadOnly={true} align='center' />
          </wj.FlexGrid>
        </div>
      </div>
    );
  }

  /**
   * Renders the wijmo grid containing any file errors.
   *
   * @returns JSX elements for the file errors.
   */
  onRenderFileErrors() {
    const errorRows = ( Object.values( this.state.errors ) ).map( ( errors ) => {
      return (
        {
          'GROUP_NAME': errors['GROUP_NAME'],
          'DEFDNIS': errors['DEFDNIS'],
          'NUMBER': errors['NUMBER'],
          'STATUS': errors['STATUS'],
          'NOTES': errors['NOTES']
        }
      );
    } );

    const displayClass = this.state.errors.length === 0
      ? 'file-management-file-errors-container-hidden'
      : 'file-management-file-errors-container';

    return (
      <div className={displayClass}>
        <div
          className='file-management-file-errors-grid-container'
          ref={this.wijmoGrid2}
        >
          <div className='file-management-file-errors-header'>Errors when file was Applied</div>
          <wj.FlexGrid
            ref={( panel ) => {
              this.wijmoPanel2 = panel; 
            }}
            itemsSource={errorRows}
            className='file-management-file-errors-grid'
          >
            <wj.FlexGridColumn width='*' header='Group Name' binding='GROUP_NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='DNIS' binding='DEFDNIS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Number' binding='NUMBER' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Status' binding='STATUS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='5*' header='Notes' binding='NOTES' isContentHtml={true} isReadOnly={true} align='center' />
          </wj.FlexGrid>
        </div>
      </div>
    );
  }

  /**
   * Renders the Apply File to a DNIS content.
   *
   * @returns JSX elements for the Apply File to a DNIS.
   */
  onRenderApplyToDNIS() {
    let programs = this.state.programs;
    let programTypes = this.state.programTypes.map( ( programType ) => {
      return <option key={programType.ROUTING_TYPE_ID} value={programType.ROUTING_TYPE_ID}>{programType.ROUTING_TYPE_NAME}</option>;
    } );
    let defaultPrograms = this.state.defaultPrograms.map( ( defaultProgram ) => {
      return <option key={defaultProgram.PDNIS} value={defaultProgram.PDNIS}>{defaultProgram.PDNIS_TEXT}</option>;
    } );

    // Check for destination filter
    if ( this.state.destination !== '0' ) {
      programs = programs.filter( ( program ) => {
        return program['DESTINATION'] === parseInt( this.state.destination, 10 );
      } );
    }
    // Check for type filter
    if ( this.state.type !== '' ) {
      programs = programs.filter( ( program ) => {
        return program['TYPE'].includes( this.state.type );
      } );
    }

    programs = programs.map( ( program ) => {
      const pdnis = program['PDNIS'];
      const dnisid = program['DNIS_ID'];
      const name = program['PROGRAM_NAME'];

      return <option key={`${dnisid} - ${name}`} value={dnisid}>{`${pdnis} - ${name}`}</option>;
    } );

    // Allowed uses for this specific file
    if ( this.props.filedata.USES ) {
      var type = this.props.filedata.USES.split( ', ' ).map( ( use ) => {
        return (
          <option key={use} value={use}>{use}</option>
        );
      } );
    }

    const valuesGroupClass = !( this.state.destination === '1' && this.state.type === 'ON NET' )
      ? 'file-management-apply-to-dnis-values-extended'
      : 'file-management-apply-to-dnis-values';

    const dnisGroupClass = !( this.state.destination === '1' && this.state.type === 'ON NET' )
      ? 'file-management-apply-to-dnis-defdnis-group-hidden'
      : 'file-management-apply-to-dnis-defdnis-group';

    return (
      <span className='file-management-apply-to-dnis'>
        <span className='file-management-apply-to-dnis-header'>{`Apply ${this.props.filedata.FILENAME} to a DNIS`}</span>
        <span className='file-management-apply-to-dnis-body'>
          <span className={valuesGroupClass}>
            <span className='file-management-apply-to-dnis-value'>
              <label className='file-management-apply-to-dnis-label'>Destination</label>
              <select className='file-management-apply-to-dnis-input' name='destination' onChange={this.onHandleChange} value={this.state.destination}>
                <option value='0'></option>
                <option value='1'>LEADGEN</option>
                <option value='2'>PROGRAM</option>
              </select>
            </span>
            <span className='file-management-apply-to-dnis-value'>
              <label className='file-management-apply-to-dnis-label'>Upload Type</label>
              <select className='file-management-apply-to-dnis-input' name='type' onChange={this.onHandleChange} value={this.state.type}>
                <option value=''></option>
                {type}
              </select>
            </span>
            <span className='file-management-apply-to-dnis-value'>
              <label className='file-management-apply-to-dnis-label'>Name</label>
              <select className='file-management-apply-to-dnis-input' name='DEST_ID' onChange={this.onHandleChange} value={this.state.DEST_ID}>
                <option value=''></option>
                {programs}
              </select>
            </span>
            <span className='file-management-apply-to-dnis-value'>
              <label className='file-management-apply-to-dnis-label'>Description</label>
              <input className='file-management-apply-to-dnis-input' type='text' name='description' onChange={this.onHandleChange} value={this.state.description} />
            </span>
          </span>
          <span className={dnisGroupClass}>
            <span className='file-management-apply-to-dnis-value' hidden={!( this.state.destination === '1' && this.state.type === 'ON NET' )}>
              <label className='file-management-apply-to-dnis-label'>Program Type</label>
              <select className='file-management-apply-to-dnis-input' name='programType' onChange={this.onHandleChange} value={this.state.programType}>
                <option value=''></option>
                {programTypes}
              </select>
            </span>
            <span className='file-management-apply-to-dnis-value' hidden={!( this.state.destination === '1' && this.state.type === 'ON NET' )}>
              <label className='file-management-apply-to-dnis-label'>Default DNIS</label>
              <select className='file-management-apply-to-dnis-input' name='DEFDNIS' onChange={this.onHandleChange} value={this.state.DEFDNIS}>
                <option value=''></option>
                {defaultPrograms}
              </select>
            </span>
          </span>
        </span>
      </span>
    );
  }

  /**
   * Renders the dialog body.
   *
   * @returns JSX elements for the dialog's body.
   */
  onRenderBody() {
    return (
      <DialogBody>
        <div className='file-management-dialog-main-container'>
          {this.onRenderFileContents()}
          {this.onRenderFileUses()}
          {this.onRenderFileErrors()}
          {this.onRenderApplyToDNIS()}
        </div>
      </DialogBody>
    );
  }

  /**
   * Renders the dialog footer.
   *
   * @returns JSX elements for the dialog's footer.
   */
  onRenderFooter() {
    return (
      <DialogFooter>
        <button style={{ 'width': '120px' }} className='file-management-buttons' onClick={this.onClickApplyToDNIS}>Apply</button>
        <button style={{ 'width': '120px', 'backgroundColor': '#b6b6b6', 'border': '1pt solid #b6b6b6' }} className='file-management-buttons' onClick={this.onClose}>Close</button>
      </DialogFooter>
    );
  }

  render() {
    let selectedItem = this.state.selectedItem;
    let showOverlay = this.state.showDeleteFromDNIS;

    if ( this.state.show ) {
      return (
        <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
          <Dialog show={this.props.show} width={90} height={90} onClose={this.onClose}>
            {this.onRenderHeader()}
            {this.onRenderBody()}
            {this.onRenderFooter()}
            <Overlay show={showOverlay} />
            <DeleteDialog
              caption={'Delete File from DNIS'}
              body={this.state.deleteBody === ''
                ? `Delete ${this.props.filedata.FILENAME} from ${selectedItem.DEFDNIS} - ${selectedItem.NAME}?`
                : this.state.deleteBody}
              show={this.state.showDeleteFromDNIS}
              onClose={this.onCloseDeleteFromDNISDialog}
              onDelete={this.onClickDeleteFromDNIS}
            />
          </Dialog>
        </PageAuthorize>
      );
    } else {
      return null;
    }

  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FileDetailsDialog )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/FileDetailsDialog.js